import { Table } from './Table'

export class Area {
    constructor(
        public id: string,
        public displayName: string,
        public description: string | null,
        public displayOrder: number,
        public preBookingWindowMinutes: number,
        public cutOffTime: Date,
        public tables: Table[]
    ) { }

    minimumReservableSeats(): number {
        return Math.min(
            ...this.tables
                .filter(table => table.reservable)
                .map(table => table.minimumSeats)
        )
    }

    maximumReservableSeats(): number {
        return Math.max(
            ...this.tables
                .filter(table => table.reservable)
                .map(table => table.maximumSeats)
        )
    }

    hasAReservableTable(): boolean {
        return this.tables.find(table => table.reservable) !== undefined
    }

    hasAWheelchairRestrictedTable(): boolean {
        return this.tables.find(table => table.wheelchairAccessible === false) !== undefined
    }

    hasADogRestrictedTable(): boolean {
        return this.tables.find(table => table.dogFriendly === false && table.reservable) !== undefined
    }

    hasAPramRestrictedTable(): boolean {
        return this.tables.find(table => table.pramAccessible === false && table.reservable) !== undefined
    }

    hasAHighchairRestrictedTable(): boolean {
        return this.tables.find(table => table.highchairFriendly === false && table.reservable) !== undefined
    }

    isHardcodedToBeHidden(): boolean {
        if (this.id === '07ac69bd-179d-4189-a343-485ebb139230') {
            // if Cocktail Geeks Outside
            return true
        }
        if (this.id === '216f35e1-ed8a-4a83-bd1a-62f80881d960') {
            // if Weston Outside Catering
            return true
        }
        if (this.id === 'e90a5d11-1af4-4898-b320-8227bd6247c7') {
            // if Weston Mobile
            return true
        }
        if (this.id === '38dbe225-6dcf-4bd5-abd2-1a427d045f2c') {
            // if Weston Dinner & Show
            return true
        }
        if (this.id === 'bdc0ff27-f4ee-4d70-a886-e7a7b9f1ee8d') {
            // if Ichiban Unreserved
            return true
        }
        if (this.id === '4bf1d17d-d54b-4fd9-8a01-2e971794c859') {
            // if Ichiban Window Seats
            return true
        }
        if (this.id === 'edecc6f4-6f1c-4184-9c83-b382ddcc493e') {
            // if Ichiban Mirror Wall
            return true
        }
        if (this.id === 'c9667781-517a-413b-9541-592bf9afa5bd') {
            // if Red Lion Function Room
            return true
        }
        return false
    }
}
